<div class="content">
  <div class="card">
    @if (data.user.frontUserId) {
      <div class="firstinfo">
        @if (data.user.frontUser.logo) {
          <img [src]="getImage(data.user.frontUser.logo)"/>
        }
        @if (!data.user.frontUser.logo) {
          <img  src="../../../../../assets/images/user_avatar.svg"/>
        }
        <div class="profileinfo">
          <h1>{{data.user.frontUser.lastName}} {{data.user.frontUser.firstName}}</h1>
          <h2>{{data.user.frontUser.organization.name}} </h2>
          @if (data.user.frontUser.targetGroup) {
            <div style="font-size: 16px; margin-bottom: 8px">{{'tg_event_info' | translate}}</div>
          }
          @if (data.user.frontUser.targetGroup) {
            <div class="targetGroup">
              @if (!editTarget) {
                <h3>{{data.user.targetGroup ? data.user.targetGroup.ageMask : ''}} </h3>
              }
              @if (editTarget) {
                <mat-form-field>
                  <mat-select placeholder="{{'user.targetGroup' | translate}}" [(ngModel)]="selectedTG">
                    @for (tg of targetGroups; track tg.id) {
                      <mat-option [value]="tg.id">
                        <span>{{tg?.ageMask}}</span>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (!editTarget) {
                <mat-icon class="edit" (click)="editTG()">edit</mat-icon>
              }
              @if (editTarget) {
                <mat-icon class="edit save" (click)="saveTG()">save</mat-icon>
              }
              @if (editTarget) {
                <mat-icon class="edit cancel" (click)="cancelEditTG()">close</mat-icon>
              }
            </div>
          }
          @if (data.user.frontUser.dateOfBirth) {
            <p class="bio">{{data.user.frontUser.dateOfBirth | date: 'dd.L.yyyy'}}</p>
          }
          @if (data.user.frontUser.mobile) {
            <p class="bio">{{data.user.frontUser.mobile}}</p>
          }
          @if (data.user.frontUser.email) {
            <p class="bio">{{data.user.frontUser.email}}</p>
          }
        </div>
      </div>
    }
    @if (!data.user.frontUserId && data.user.guestUserId) {
      <div class="firstinfo">
        <img src="../../../../../assets/images/user_avatar.svg"/>
        <div class="profileinfo">
          <h1>{{data.user.lastName}} {{data.user.firstName}}</h1>
          @if (data.user.groupRegistration) {
            <p>{{data.user.nameOfOrganization}} {{data.user.numberOfPeople}} {{'people' | translate}}</p>
          }
          @if (data.user.mobile) {
            <p class="bio">{{data.user.mobile}}</p>
          }
          @if (data.user.email) {
            <p class="bio">{{data.user.email}}</p>
          }
        </div>
      </div>
    }
    @if (userData) {
      <div class="action-item"  style="float: right; display: flex">
        @if (data.event.additionalForm || data.event.guestEvent) {
<mat-icon (click)="editUserData()" style="width: 70px;font-size: 70px; height: 70px;
    margin-right: 15px; cursor:pointer;">edit</mat-icon>
        }
        <img (click)="downloadPDF2()" style="width: 70px" src="../../../../../assets/images/pdf.svg"/>
      </div>
    }
  </div>
</div>
